const DeliveryMethodEnum = {
  ELECTRONIC_DELIVERY: { value: 'ED', name: 'Electronic Delivery' },
  PAPER: { value: 'P', name: 'Overnight Delivery' },
};

export default DeliveryMethodEnum;
